var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container DCDetail" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("DC.DCDetail"), name: "1" } },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _vm.isSave
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.DcSaveDCMasterData,
                              expression: "DcSaveDCMasterData",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.saveDetail },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                      )
                    : _vm._e(),
                  _vm.isSubmit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.DcUpdateDCMasterData,
                              expression: "DcUpdateDCMasterData",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.submitDetail },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.submit")))]
                      )
                    : _vm._e(),
                  _vm.isExamine
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SubmitCMasterDataDCMasterData,
                              expression: "SubmitCMasterDataDCMasterData",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.approval },
                        },
                        [_vm._v(_vm._s(_vm.$t("supplierManage.audit")) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "info_box_father" }, [
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("div", { staticClass: "info_box_title" }, [
                      _c("p", { staticClass: "line" }),
                      _c("p", { staticClass: "info_title" }, [
                        _vm._v("Basic Information"),
                      ]),
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "DetailForm",
                        attrs: {
                          model: _vm.DetailForm,
                          rules: _vm.DetailRules,
                          "label-width": "180px",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.DCNumber"),
                                      prop: "supplierCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "20",
                                        clearable: "",
                                        disabled: !(
                                          _vm.emplFlag == "MDM" &&
                                          (_vm.isExamine || _vm.isSubmit)
                                        ),
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.supplierCodeBlur($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.DetailForm.supplierCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "supplierCode",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "DetailForm.supplierCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("common.status"),
                                      prop: "status",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        table: "TM_SUPPLIER",
                                        field: "START_STATE",
                                        disabled:
                                          !_vm.isSubmit ||
                                          _vm.emplFlag == "SUP",
                                      },
                                      model: {
                                        value: _vm.DetailForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.createDate"),
                                      prop: "createDate",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "date",
                                        "value-format": "yyyy-MM-dd",
                                        disabled: "",
                                        placeholder: _vm.$t("common.selDate"),
                                      },
                                      model: {
                                        value: _vm.DetailForm.createDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "createDate",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.createDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.supplierName"),
                                      prop: "supplierNameShort",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "33",
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.supplierNameShort,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "supplierNameShort",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DetailForm.supplierNameShort",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.supplierNameShort"),
                                      prop: "supplierName",
                                      rules:
                                        _vm.emplFlag == "MDM"
                                          ? _vm.DetailRules.supplierName
                                          : [],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "33",
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.supplierName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "supplierName",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.supplierName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.DCType"),
                                      prop: "dctype",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      attrs: {
                                        clearable: "",
                                        table: "TM_SUPPLIER",
                                        field: "DC_TYPE",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.dctype,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "dctype",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.dctype",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "国家", prop: "country" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择",
                                          disabled:
                                            !_vm.isSave && !_vm.isSubmit,
                                        },
                                        on: { change: _vm.countryChange1 },
                                        model: {
                                          value: _vm.DetailForm.country,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.DetailForm,
                                              "country",
                                              $$v
                                            )
                                          },
                                          expression: "DetailForm.country",
                                        },
                                      },
                                      _vm._l(_vm.countryList, function (item) {
                                        return _c("el-option", {
                                          key: item.tmAreaId,
                                          attrs: {
                                            clearable: "",
                                            label: item.name,
                                            value: item.tmAreaId,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "省份", prop: "province" },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择",
                                          disabled:
                                            !_vm.isSave && !_vm.isSubmit,
                                        },
                                        on: { change: _vm.provinceChange2 },
                                        model: {
                                          value: _vm.DetailForm.province,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.DetailForm,
                                              "province",
                                              $$v
                                            )
                                          },
                                          expression: "DetailForm.province",
                                        },
                                      },
                                      _vm._l(_vm.provinceList, function (item) {
                                        return _c("el-option", {
                                          key: item.tmAreaId,
                                          attrs: {
                                            clearable: "",
                                            label: item.name,
                                            value: item.tmAreaId,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "市/县", prop: "city" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择",
                                          disabled:
                                            !_vm.isSave && !_vm.isSubmit,
                                        },
                                        on: { change: _vm.cityChange2 },
                                        model: {
                                          value: _vm.DetailForm.city,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.DetailForm,
                                              "city",
                                              $$v
                                            )
                                          },
                                          expression: "DetailForm.city",
                                        },
                                      },
                                      _vm._l(_vm.cityList, function (item) {
                                        return _c("el-option", {
                                          key: item.tmAreaId,
                                          attrs: {
                                            clearable: "",
                                            label: item.name,
                                            value: item.tmAreaId,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.tmAreaId"),
                                      prop: "tmAreaId",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "请选择",
                                          disabled:
                                            !_vm.isSave && !_vm.isSubmit,
                                        },
                                        on: { change: _vm.AreaChange },
                                        model: {
                                          value: _vm.DetailForm.tmAreaId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.DetailForm,
                                              "tmAreaId",
                                              $$v
                                            )
                                          },
                                          expression: "DetailForm.tmAreaId",
                                        },
                                      },
                                      _vm._l(_vm.AreaList, function (item) {
                                        return _c("el-option", {
                                          key: item.tmAreaId,
                                          attrs: {
                                            clearable: "",
                                            label: item.name,
                                            value: item.tmAreaId,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.address"),
                                      prop: "address",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "33",
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.address,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "address",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "DetailForm.address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.postCode"),
                                      prop: "postCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                        maxLength: "6",
                                        onkeyup:
                                          "this.value=this.value.replace(/\\D/g,'')",
                                      },
                                      model: {
                                        value: _vm.DetailForm.postCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "postCode",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.postCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "联系人", prop: "linkman" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        maxlength: "20",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.linkman,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "linkman",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.linkman",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.telephoneNo"),
                                      prop: "telephoneNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                        maxlength: "20",
                                      },
                                      model: {
                                        value: _vm.DetailForm.telephoneNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "telephoneNo",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.telephoneNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("DC.emailAddress"),
                                      prop: "emailAddress",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "50",
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.emailAddress,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "emailAddress",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.emailAddress",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("common.remarks"),
                                      prop: "description",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "33",
                                        clearable: "",
                                        disabled: !_vm.isSave && !_vm.isSubmit,
                                      },
                                      model: {
                                        value: _vm.DetailForm.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DetailForm,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "DetailForm.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.emplFlag != "SUP"
                  ? _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("div", { staticClass: "info_box_title" }, [
                          _c("p", { staticClass: "line" }),
                          _c("p", { staticClass: "info_title" }, [
                            _vm._v("ADP"),
                          ]),
                        ]),
                        _c(
                          "el-table",
                          {
                            ref: "fpaLogisticRates",
                            staticClass: "campaign_table PQCP",
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              data: _vm.fpaLogisticRates,
                              "max-height": "500",
                              border: "",
                              "highlight-current-row": "",
                            },
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                attrs: {
                                  align: "center",
                                  label: "Transportation",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationRate",
                                    label: "New Item Rate without VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row
                                                      .transportationRate,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1114247278
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationRateWithVat",
                                    label: "New Item Rate with VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row
                                                      .transportationRateWithVat,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1094981903
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationVat",
                                    label: "VAT Rate",
                                    "show-overflow-tooltip": "",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPercent")(
                                                    scope.row.transportationVat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    515706146
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "transportationVatValue",
                                    label: "New Item VAT Value",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row
                                                      .transportationVatValue,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1060814788
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-table-column",
                              {
                                attrs: { align: "center", label: "Warehouse" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseRate",
                                    label: "New Item Rate without VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row.warehouseRate,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    622825429
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseRateWithVat",
                                    label: "New Item Rate with VAT",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row
                                                      .warehouseRateWithVat,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3423021844
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseVat",
                                    label: "VAT Rate",
                                    "show-overflow-tooltip": "",
                                    "min-width": "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("toPercent")(
                                                    scope.row.warehouseVat
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3567329209
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    align: "center",
                                    prop: "warehouseVatValue",
                                    label: "New Item VAT Value",
                                    "show-overflow-tooltip": "",
                                    "min-width": "180",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("fix")(
                                                    scope.row.warehouseVatValue,
                                                    6
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3942169791
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "adpCost",
                                label: "Total ADP Cost(without VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "180",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("fix")(
                                                scope.row.adpCost,
                                                6
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4003825004
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "adpCostWithVat",
                                label: "Total ADP Cost(with VAT)",
                                "show-overflow-tooltip": "",
                                "min-width": "180",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("fix")(
                                                scope.row.adpCostWithVat,
                                                6
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                479792237
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.emplFlag != "SUP"
                  ? _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("div", { staticClass: "info_box_title" }, [
                          _c("p", { staticClass: "line" }),
                          _c("p", { staticClass: "info_title" }, [
                            _vm._v("Planning Service"),
                          ]),
                        ]),
                        _c(
                          "el-form",
                          { ref: "listForm", attrs: { model: _vm.listForm } },
                          [
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 9 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            "Agreed Price(price/case or tray in RMB with VAT)",
                                          prop: "agreedPriceWithVat",
                                          "label-width": "290px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.listForm.agreedPriceWithVat,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "agreedPriceWithVat",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "listForm.agreedPriceWithVat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "per",
                                          prop: "agreedPriceWithVatUnit",
                                          "label-width": "60px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value:
                                              _vm.listForm
                                                .agreedPriceWithVatUnit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "agreedPriceWithVatUnit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "listForm.agreedPriceWithVatUnit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 9 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            "Agreed Price(price/case or tray in RMB without VAT)",
                                          prop: "agreedPrice",
                                          "label-width": "300px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.listForm.agreedPrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "agreedPrice",
                                                $$v
                                              )
                                            },
                                            expression: "listForm.agreedPrice",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "per",
                                          prop: "agreedPriceUnit",
                                          "label-width": "60px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.listForm.agreedPriceUnit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "agreedPriceUnit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "listForm.agreedPriceUnit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "VAT Rate",
                                          prop: "settleVat",
                                          "label-width": "290px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.listForm.settleVat,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "settleVat",
                                                $$v
                                              )
                                            },
                                            expression: "listForm.settleVat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "Settle",
                                          prop: "settleDcName",
                                          "label-width": "300px",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: { disabled: "" },
                                          model: {
                                            value: _vm.listForm.settleDcName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.listForm,
                                                "settleDcName",
                                                $$v
                                              )
                                            },
                                            expression: "listForm.settleDcName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "2" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              ) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("common.opinion"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalResults"),
                    prop: "auditStatus",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.approvaForm.auditStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvaForm, "auditStatus", $$v)
                        },
                        expression: "approvaForm.auditStatus",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "approve" } }, [
                        _vm._v(_vm._s(_vm.$t("common.pass"))),
                      ]),
                      _c("el-radio", { attrs: { label: "reject" } }, [
                        _vm._v(_vm._s(_vm.$t("common.noPass"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalRemarks"),
                    prop: "remarks",
                    rules:
                      _vm.approvaForm.auditStatus == "reject"
                        ? _vm.approvaForm.remarks
                        : [],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "remarks", $$v)
                      },
                      expression: "approvaForm.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }